
<script>
import Input from '@components/Input'
import Button from '@components/Button'
import Dialog from '@components/Dialog'
import Loading from '@components/Loading'
import ImageLoader from '@components/ImageLoader'
import isValidCpf from '@/utils/is-valid-cpf'
import { isEmpty } from 'lodash'
import { mapActions } from 'vuex'
import { mask } from 'vue-the-mask'

export default {
  name: 'FormCadastro',
  directives: { mask },
  components: { Input, Dialog, Button, Loading, ImageLoader },
  props: {
    formStyle: { type: String, default: '' },
    labelColor: { type: String, default: '' },
    errorColor: { type: String, default: '' },
    buttonStyle: { type: String, default: '' },
    scale: { type: Number, default: 1 }
  },
  data: () => ({
    loading: false,
    nome_: '',
    email_: '',
    cpf_: '',
    apiError: '',
    errors: {
      nome: '',
      email: '',
      cpf: ''
    }
  }),
  computed: {
    nome: {
      get () {
        return this.nome_.trim()
      },
      set (val) {
        this.nome_ = val
      }
    },
    cpf: {
      get () {
        return this.cpf_.trim()
      },
      set (val) {
        this.cpf_ = val
      }
    },
    email: {
      get () {
        return this.email_.trim()
      },
      set (val) {
        this.email_ = val
      }
    }
  },
  methods: {
    ...mapActions(['cadastrar']),
    goToLogin () {
      window.location.href = this.wl.urls.login
    },
    validate () {
      let isValid = true
      const validations = {
        nome: [
          (v) => isEmpty(v) && this.wl.strings['err-nome-vazio'],
          (v) =>
            !/^([a-zA-Z\u00C0-\u017F\s]{3,})$/.test(v) &&
            this.wl.strings['err-nome-invalido']
        ],
        cpf: [
          (v) => isEmpty(v) && this.wl.strings['err-cpf-vazio'],
          (v) => !isValidCpf(v) && this.wl.strings['err-cpf-invalido']
        ],
        email: [(v) => isEmpty(v) && this.wl.strings['err-email-vazio']]
      }
      Object.keys(validations).forEach((field) => {
        validations[field].every((isInvalid) => {
          const error = isInvalid(this[field])
          if (error) {
            this.$set(this.errors, field, error)
            isValid = false
            return false
          }
          return true
        })
      })
      return isValid
    },
    resetarErro (key) {
      this.$set(this.errors, key, '')
    },
    handleCadastro () {
      if (typeof dataLayer !== 'undefined') dataLayer.push({ event: 'form_conta_gratis' })
      if (this.validate()) {
        this.loading = true
        this.cadastrar({
          nome: this.nome,
          cpf: this.cpf,
          email: this.email,
          linkAcesso: this.wl.urls.login
        })
          .then(() => {
            this.nome = ''
            this.cpf = ''
            this.email = ''
            this.$refs.successDialog.open()
          })
          .catch((e) => {
            if (e.response && e.response.data && e.response.data.message) {
              this.apiError = e.response.data.message
              this.$refs.errorDialog.open()
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
}
</script>

<template>
  <aside :style="{'--scale': scale}">
    <form
      :style="formStyle"
      action="javascript:;"
      @submit="handleCadastro"
    >
      <Input
        id="input-nome"
        v-model="nome"
        :scale="scale"
        :label-color="labelColor"
        :error-color="errorColor"
        :label="wl.strings['label-nome']"
        :error="errors.nome"
        :border-color="wl.colors.primary"
        @input="resetarErro('nome')"
      />
      <Input
        v-model="cpf"
        v-mask="'###.###.###-##'"
        :scale="scale"
        :label-color="labelColor"
        :error-color="errorColor"
        :error="errors.cpf"
        label="CPF"
        class="cpf-input"
        placeholder="000.000.000-00"
        :border-color="wl.colors.primary"
        @input="resetarErro('cpf')"
      />
      <Input
        id="input-email"
        v-model="email"
        :scale="scale"
        :label-color="labelColor"
        :error-color="errorColor"
        :label="wl.strings['label-email']"
        type="email"
        :error="errors.email"
        :border-color="wl.colors.primary"
        @input="resetarErro('email')"
      />
      <Button
        :color="wl.colors.secondary"
        :text-color="wl.colors.on.secondary"
        :text="wl.strings['btn-cadastrar']"
        size="md"
        :style="`transform: scale(${scale})`"
      />
    </form>
    <Dialog
      ref="errorDialog"
      error
      style="z-index: 26"
    >
      <template v-slot:title>
        <span v-html="wl.strings['dialog-error-title']" />
      </template>
      <template v-slot:text>
        {{ apiError }}
      </template>
    </Dialog>
    <Dialog
      ref="successDialog"
      style="z-index: 26"
    >
      <template v-slot:title>
        <ImageLoader
          :url="wl.images.WOLIFLIX_DARK_LOGO"
          style="height: 43px; width: 199px;"
        />
      </template>
      <template v-slot:text>
        <div
          style="
            font: normal calc(40px * var(--scale))/calc(45px * var(--scale)) 'Open Sans';
            margin-top: 20px;
          "
          v-html="wl.strings['dialog-cadastro-success-message']"
        />
        <Button
          size="lg"
          :color="wl.colors.primary"
          :text-color="wl.colors.on.primary"
          :text="wl.strings['btn-login']"
          style="margin: 30px auto;"
          @click="() => goToLogin()"
        />
      </template>
    </Dialog>
    <Loading :visible="loading" />
  </aside>
</template>

<style lang="scss" scoped>
aside {
  position: relative;
  padding: calc(15px * var(--scale));
}
</style>
